export const STUDENT_PAGE_LOCAL_STORAGE_KEY = '/students';
export const STUDENT_PAGE_DEFAULT_ORDER_BY = 'lastname';
